import React from "react";
import ReactDOM from "react-dom";

import ViihdeFooter from "components/footer/ViihdeFooter";
import store from 'components/footer/ViihdeFooterStore';

const items = [
  { key: 'viihde-footer-1', link: 'https://elisaviihde.fi/ohjelmaopas/', label: 'Ohjelmaopas', icon: 'ea-icon--program-guide' },
  { key: 'viihde-footer-2', link: 'https://elisaviihde.fi/tallenteet', label: 'Tallenteet', icon: 'ea-icon--recordings' },
  { key: 'viihde-footer-3', link: 'https://elisaviihde.fi/vuokraamo', label: 'Vuokraamo', icon: 'ea-icon--vuokraamo' },
  { key: 'viihde-footer-4', link: 'https://elisaviihde.fi/ohjelmakirjastot', label: 'Ohjelmakirjastot', icon: 'ea-icon--ohjelmakirjasto' },
  { key: 'viihde-footer-5', link: 'https://elisaviihde.fi/sport', label: 'Sport', icon: 'ea-icon--sports' },
  { key: 'viihde-footer-6', link: 'https://elisaviihde.fi/maksukanavat', label: 'Maksukanavat', icon: 'ea-icon--pay-channels' }
];

function init()
{
  store.setItems(items);
  ReactDOM.render(<ViihdeFooter />, document.getElementById('footer'));
}

export default { init };



// WEBPACK FOOTER //
// ./web/js/viihde-footer.js